import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { DynamicDialogService } from 'src/app/dynamic-dialog/dynamic-dialog.service';
import { VehicleState } from 'src/app/models/vehicleState';
import { LocalizeService } from 'src/app/services/localize.service';
import { TenantState } from 'src/app/store/state/tenant.state';
import { Vehicle } from '../../models/vehicle';
import { Observable } from 'rxjs';
import { Dictionary } from 'lodash';
import * as _ from 'lodash';
import { TelematicDriverService } from 'src/app/shared/services/telematic-driver.service';

@Component({
    selector: 'app-vehicle-header',
    templateUrl: './vehicle-header.component.html',
    styleUrls: ['./vehicle-header.component.css'],
    standalone: false
})
export class VehicleHeaderComponent implements OnInit {
  @SelectSnapshot(TenantState.getLanguage) getLanguage: string;
  displayOdometer: any;
  displayOperationDuration: string;
  currentLanguage: string;

  @Input() vehicle: Vehicle;
  @Input() vehicleState: VehicleState;
  @Input() telematicDriver$: Observable<Dictionary<string>>;
  serialNumber: any;

  constructor(
    private localizeService: LocalizeService,
    private dialogService: DynamicDialogService,
    private telematicDriverService: TelematicDriverService
  ) {

  }

  ngOnInit(): void {
    this.currentLanguage = this.getLanguage;

    this.displayOdometer =
      this.localizeService.getDisplayOdometer(
        this.currentLanguage,
        this.vehicleState?.odometer);

    this.displayOperationDuration =
      this.localizeService.getHours(
        this.vehicleState?.engine?.operationDuration);    

  }
  ngOnChanges(changes: SimpleChanges): void {
    this.currentLanguage = this.getLanguage;

    this.displayOdometer =
      this.localizeService.getDisplayOdometer(
        this.currentLanguage,
        this.vehicleState?.odometer);

    this.displayOperationDuration =
      this.localizeService.getHours(
        this.vehicleState?.engine?.operationDuration);
  }

  showDateDetails(): void {
    this.dialogService.openUpdateDateListDialog(this.vehicleState);
  }

  showDriverDetails(dict: Dictionary<string>): void {
    this.dialogService.openDriverDialog(this.vehicleState, dict);
  }

  displayDriverDict(dict: Dictionary<string>): string {
    return this.telematicDriverService.driverToString(
      dict, 
      this.vehicleState.driverStatusList)[0];
  }
}
